import { createSelector } from 'reselect';

import { GIGABIT_SPEED } from '~/src/features/full-buy/consts';
import { TState } from '~/src/store';

import { ETariffFilters } from '../initialState';
import { IFullBuyTariff } from '../tariffTransformer';

const MEGABIT_SPEED = 100;

// Возвращает тарифы по переданным фильтрам
const getfilteredPack = (packages: IFullBuyTariff[], filterType: ETariffFilters) => {
    if (filterType === ETariffFilters.MONO) {
        return packages?.filter((pack) => pack.isMono);
    }

    if (filterType === ETariffFilters.KP) {
        return packages?.filter((pack) => !pack.isMono);
    }

    if (filterType === ETariffFilters.SPEED100) {
        return packages?.filter((el) => el.available_on_address_restrict || el.speed <= MEGABIT_SPEED);
    }

    if (filterType === ETariffFilters.SPEED_LESS_1000) {
        return packages?.filter((el) => el.speed < GIGABIT_SPEED);
    }

    return packages;
};

// Возвращает тарифы по указанной линейке
const getTariffsByTariffLine = (packages: IFullBuyTariff[], tariffLineAlias: string) => {
    if (!tariffLineAlias) {
        return packages;
    }

    return packages.filter(tariffPack => tariffPack.tariffLineAlias.includes(tariffLineAlias));
};

// Выбирает тарифы отобранные по фильтрам и линейкам
export const selectFilteredTariffs = createSelector(
    [
        (state: TState) => state.fullBuy,
    ],
    ({ tariffs: tariffPackages, tariffLineAlias, filters }): IFullBuyTariff[] => {
        let filteredPackages: IFullBuyTariff[] = tariffPackages;

        if (tariffLineAlias) {
            filteredPackages = getTariffsByTariffLine(tariffPackages, tariffLineAlias);
        }

        filters?.forEach((filterType) => {
            filteredPackages = getfilteredPack(filteredPackages, filterType);
        });

        return filteredPackages;
    },
);
